import { Component, OnInit } from '@angular/core';
import { Sensor, UserGroup } from '@models';
import { AppMessageService } from '@services/message.service';
import { SensorService } from '@services/sensor.service';
import { UserService } from '@services/user.service';
import { AppComponent } from 'app/app.component';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import { SensorMapping } from 'app/shared/classes/sensorMapping';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts;

export interface SensorLabelModalParams {
  uuid: string;
  btMacAddressPrefixes: { [key: string] : string };
}


@Component({
  standalone: false,
  selector: 'app-sensor-label-modal',
  templateUrl: './sensor-label-modal.component.html',
  styleUrls: ['./sensor-label-modal.component.scss']
})

export class SensorLabelComponent implements OnInit, SensorLabelModalParams {

  public auth = new Authorization();
  public common = new CommonShared();
  public mapping = new SensorMapping();
  
  modalDragOn: boolean = false;

  public uuid: string;
  public QRLabel: string;
  public QRCode: string;
  public btMacAddressPrefixes: { [key: string] : string };

  public allSensors: Sensor[];
  public userGroups: UserGroup[];
  public changeLogNotes: string;

  public username: string;
  public globalSwitch: boolean;

  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService,
              public _sensorService: SensorService, public _appMessageService: AppMessageService,
              public _userService: UserService, private global: AppComponent) {
    this.globalSwitch = global.globalSwitch;
  }


  ngOnInit(): void {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      () => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }

  startUp(): void {
    this.QRCode = this.common.extractMacAddressFromUUID(this.uuid);
    this.QRLabel = this.QRCode.substring(0, 8) + '\n' + this.QRCode.substring(9, 17)
  }

  
  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }

  
  downloadPDF(action: string, divID: string) {
    const docDefinition = {
      pageSize: {
        width: 64,
        height: 'auto'
      },
      pageMargins: [ 2, 2, 2, 2 ],
      content: [
        { qr: this.QRCode, version: 2, mode: 'alphanumeric', eccLevel: 'M', fit: 50 },
        { text: this.QRLabel, alignment: 'left', fontSize: 12 }
      ],
    };

    if (action == 'open') {
      pdfMake.createPdf(docDefinition).open();
    }
    else if (action == 'download') {
      const fileName = this.QRLabel.replace(/:/g, '-');
      pdfMake.createPdf(docDefinition).download(fileName);
    }
  }


}